// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1378": "37ef96ff4092","2723": "4254ae83d63f","3245": "7f489da46fc5","3499": "cf32159b8363","6332": "07ec53b6952d","7683": "0999ba10d2ff",}[chunkId] + ".css"
}